module.exports = __webpack_public_path__ + "static/media/cogra.6e1f767f.svg";